import React from 'react'

function SubscriptionDetail() {
    return (
        <div>SubscriptionDetail</div>
    )
}

export default SubscriptionDetail